import { gql } from '@apollo/client';

export const DELETE_REGULAR_HEALTH_CHECKUP_REPORT = gql`
  mutation deleteRegularHealthCheckupReport($input: DeleteRegularHealthCheckupReportInput!) {
    deleteRegularHealthCheckupReport(input: $input) {
      id
    }
  }
`;

export interface DeleteRegularHealthCheckupReportQueryVariables {
  input: {
    id: string;
  };
}
